import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import ContainerHeader from '../../../components/ContainerHeader/index';

import * as addTeam from '../../../actions/teamdetails';
import * as regData from '../../../../appConstants'

class AddTeam extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.id,
            name: '',
            isSet:false
        };
        // console.log('this.state.customer', this.state.customer);
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleSave = event => {
        event.preventDefault();
        // console.log("name", this.state.name)
        if (this.state.id) {
            // console.log('this.state.id', this.state.id)
            // this.props.actions.fetchTeamDetails(this.state.id);
            this.props.actions.updateTeamDetails({"committee_id":this.state.id, "committee_name": this.state.name });
        }
        else
            this.props.actions.addTeamDetails({ "committee_name": this.state.name });
    };

    componentDidMount() {
        // console.log('componentDidMount', this.state.id)
        if (this.state.id) {
            // console.log('this.state.id', this.state.id)
            this.props.actions.fetchTeamDetails(this.state.id);
        }
        else{
            this.setState({ name: '' });
            this.setState({ id: '' });
        }
    }

    render() {
        const { match, teamDetails } = this.props;
        // console.log('teamDetails',teamDetails)
        let result = null;
        if (teamDetails && teamDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (teamDetails && teamDetails.apiGetResult && teamDetails.teamdetails && !this.state.isSet) {
            this.state.id = teamDetails.teamdetails.committee_id;
            this.state.name = teamDetails.teamdetails.committee_name;
            this.state.isSet = true;
        }
        return (
            <div className="slideInUpTiny ">
            {result}
                <ContainerHeader title="Add Team" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSave}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-primary text-white">Team Details</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <TextValidator margin="normal" fullWidth
                                                name="name" label="Team Name" placeholder="Team Name"
                                                validators={['required',regData.regexAlphaNumeric,regData.regexAlphaNumericLength]}
                                                errorMessages={['This field is required',regData.messageAlphaNumeric,regData.messageLength]}
                                                value={this.state.name} onChange={this.handleChange('name')}
                                            />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="col-12 text-right">
                                <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>
                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={()=>{this.props.history.push('/team/team-list')}}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log("state==>",state)
    const { teamDetails } = state
    const { match } = ownProps
    return { match, teamDetails, params: ownProps.match.params }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(addTeam, dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddTeam));



// WEBPACK FOOTER //
// ./app/teamdetails/addteam/index.js